var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { Component } from 'react';
import TinyDatePicker from 'tiny-date-picker';
import './DatePicker.css';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { lang } from 'helpers/i18n';
import { Input } from 'elements';
import PropTypes from 'prop-types';
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.id = "datepicker-".concat(_this.props.name);
        _this.handleHourChange = function (event) {
            _this.setState({ hour: Number(event.target.value) });
        };
        _this.handleMinutesChange = function (event) {
            _this.setState({ minutes: Number(event.target.value) });
        };
        _this.handleKeyClick = function (event) {
            console.log('event.keyCode', event.charCode);
            if (_this.props.onKeyPress)
                _this.props.onKeyPress(event.charCode);
        };
        _this.handleChange = function (state) {
            var date = state.date, hour = state.hour, minutes = state.minutes;
            if (date && _this.props.withTime) {
                date.setHours(hour);
                date.setMinutes(minutes);
            }
            _this.props.onChange(_this.props.name, date);
        };
        _this.ceros = function (value) {
            if (value > 9) {
                return String(value);
            }
            return '0'.concat(String(value));
        };
        var date = props.date ?
            typeof props.date === 'string'
                ? new Date(props.date)
                : props.date
            :
                new Date();
        _this.state = {
            date: date,
            hour: date.getHours(),
            minutes: date.getMinutes()
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        var _this = this;
        var _a;
        this.picker = TinyDatePicker(document.getElementById(this.id), __assign(__assign({ mode: this.props.mode || DatePicker.defaultProps.mode, hilightedDate: this.state.date }, this.props.min ? { min: this.props.min } : undefined), { max: (_a = this.props.max) !== null && _a !== void 0 ? _a : null, lang: lang === 'es'
                ? {
                    days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                    months: [
                        'Enero',
                        'Febrero',
                        'Marzo',
                        'Abril',
                        'Mayo',
                        'Junio',
                        'Julio',
                        'Agosto',
                        'Septiembre',
                        'Octubre',
                        'Noviembre',
                        'Diciembre'
                    ],
                    today: 'Hoy'
                }
                : {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December'
                    ],
                    today: 'Today'
                }, dayOffset: lang === 'es' ? 1 : 0 }));
        this.picker.on('select', function (_, dp) {
            var selectedDate = new Date(dp.state.selectedDate);
            if (_this.props.startDay) {
                selectedDate.setHours(0, 0, 0, 0);
            }
            else if (!_this.props.startDay && _this.props.endDay) {
                selectedDate.setHours(23, 59, 59, 999);
            }
            if (_this.props.startDay && _this.props.endDay) {
                console.error('Se ha seleccionado startDay y endDay, se tendrá en cuenta startDay y se ignorará endDay');
            }
            console.log('selectedDate: ', selectedDate);
            _this.setState({ date: selectedDate });
        });
        this.picker.on('open', function (_, dp) {
            _this.props.onOpen();
        });
        this.picker.on('close', function (_, dp) {
            _this.props.onClose();
        });
    };
    DatePicker.prototype.componentWillUnmount = function () {
        this.picker.off();
    };
    DatePicker.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (this.state !== nextState)
            this.handleChange(nextState);
    };
    DatePicker.prototype.render = function () {
        var _a = this.props, date = _a.date, name = _a.name, withTime = _a.withTime, onChange = _a.onChange, onOpen = _a.onOpen, onClose = _a.onClose, mode = _a.mode, onKeyPress = _a.onKeyPress, max = _a.max, hideTodayButton = _a.hideTodayButton, props = __rest(_a, ["date", "name", "withTime", "onChange", "onOpen", "onClose", "mode", "onKeyPress", "max", "hideTodayButton"]);
        var _b = this.state, hour = _b.hour, minutes = _b.minutes;
        return (React.createElement("div", __assign({}, props),
            React.createElement(WrapperDatePicker, { id: this.id, hideTodayButton: hideTodayButton }),
            withTime && (React.createElement(TimePicker, null,
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'hora', value: String(hour), min: 0, max: 23, onKeyPress: this.handleKeyClick, onChange: this.handleHourChange })),
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'minutos', value: String(minutes), min: 0, max: 59, onKeyPress: this.handleKeyClick, onChange: this.handleMinutesChange }))))));
    };
    DatePicker.defaultProps = {
        mode: 'dp-permanent',
        hideTodayButton: false
    };
    return DatePicker;
}(Component));
export default DatePicker;
var WrapperDatePicker = cxs('div')(function (_a) {
    var _b, _c;
    var hideTodayButton = _a.hideTodayButton;
    return (__assign(__assign({ color: Theme.color.secondary, marginTop: Theme.size.space[1] }, hideTodayButton ? {
        ' .dp-today': {
            display: 'none'
        }
    } : undefined), (_b = { ' .dp-cal-header': {
                fontSize: Theme.fontSize.big
            }, ' .dp-cal .dp-selected, .dp-cal a:hover, .dp-cal a:focus': {
                color: Theme.color.primary
            }, ' .dp-days a:focus, .dp-days a:hover, .dp-cal .dp-selected, .dp-years, .dp-months': {
                outline: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
            }, ' .dp-col-header': {
                color: Theme.color.placeholder,
                borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
            }, ' .dp-cal-footer': (_c = {
                    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
                },
                _c[mediaQueries.desktop] = {
                    borderBottom: 0
                },
                _c), ' .dp-edge-day, .dp-day-disabled': {
                color: Theme.color.hairline
            } }, _b[mediaQueries.desktop] = {
    // outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    }, _b)));
});
WrapperDatePicker.propTypes = {
    hideTodayButton: PropTypes.bool
};
var TimePicker = cxs('div')((_a = {
        padding: Theme.size.space[1],
        textAlign: 'center',
        borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _a[mediaQueries.desktop] = {
        border: 0,
        outline: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _a));
var TimeInput = cxs('div')({
    width: '4em',
    margin: "0 ".concat(Theme.size.space[1]),
    display: 'inline-block'
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/DatePicker.tsx
// module id = 947
// module chunks = 0